// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1HIep","label":"Labeled_label__deT16","divider":"Labeled_divider__oWNqQ"};